<sc-lateral-menu-wrapper [isOpen]="!!openMenu" (closeModal)="closeLateralMenu()">
  <sc-pas-selector *ngIf="!!openMenu" [title]="selectorTitle" [backToBranchIconSrc]="selectedBranchIcon"
    [runAnimation]="openMenu" [rowData]="producers" (onClick)="handleOnPasClick($event)">
  </sc-pas-selector>
</sc-lateral-menu-wrapper>

<div class="background"></div>
<div class="single-signature-credit-container">
  <div>
    <img class="logo-sc" src="assets/images/financial-services-sc.png" alt="logo san cristobal">
  </div>
  <div>
    <p class="main-title title">
      Créditos a sola firma
    </p>
  </div>
  <div *ngIf="!!notAllowedCuit">
    <p class="subtitle section-title">
      Actualmente no cuenta con acceso
      para operar con Servicios Financieros.
    </p>
    <p class="info">
      En caso que desee conocer y operar con nosotros,
      puede contactarse por correo a la siguiente casilla:
      <a href="mailto:consultas@sancristobalsf.com.ar">consultas@sancristobalsf.com.ar</a>
      <br>
      <br>
      Muchas gracias.
    </p>
  </div>
  <div *ngIf="!notAllowedCuit">
    <p class="subtitle section-title">
      Para operar con Servicios Financieros seleccione un productor.
    </p>
    <div class="button-container">
      <sc-button (onClick)="openPASSelector()" id="continueToPAS" [loading]="loading">Continuar</sc-button>
    </div>
  </div>
</div>